import React, { useState, useEffect } from "react";
import { useLang } from "@/i18n";
import { loadAnalytics } from "@/lib/analytics";

export const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (consent === "accepted") loadAnalytics();
    else if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    loadAnalytics();
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[60] bg-[#1A1F2C] text-white px-4 sm:px-8 lg:px-16 py-5">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 max-w-6xl mx-auto">
        <p className="text-sm text-white/80 leading-relaxed">{t("cookie_text")}</p>
        <div className="flex items-center gap-3 shrink-0">
          <button data-testid="cookie-reject" onClick={reject}
            className="text-xs tracking-luxe uppercase border border-white/40 px-5 py-2.5 hover:bg-white/10 transition-colors">
            {t("reject")}
          </button>
          <button data-testid="cookie-accept" onClick={accept}
            className="text-xs tracking-luxe uppercase bg-[#C5A880] text-[#1A1F2C] px-6 py-2.5 hover:bg-white transition-colors">
            {t("accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
